// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","date":"G031ad8 Gd104a2 G42bbcd Gefef6b G4aec39 Gd71c60 undefined G813e5d"};